import React from "react";

export default ({ style = {}, fill = "#A3A3A3" }) => (
    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.29961 7.8918L1.59961 15.5918L0.0996093 14.1918L6.39961 7.8918L0.0996088 1.5918L1.59961 0.191797L9.29961 7.8918Z"
            fill={fill}
        />
    </svg>
);
